import React from 'react';

import { ActivityCodesFilter } from 'components/common/GlobalFiltersInPage/components/ActivityCodesFilter/ActivityCodesFilter';
import { ActivityForwardFragnetFilter } from 'components/common/GlobalFiltersInPage/components/ActivityForwardFragnetFilter/ActivityForwardFragnetFilter';
import { ActivityTypeFilter } from 'components/common/GlobalFiltersInPage/components/ActivityTypeFilter/activityTypeFilter';
import { Assignee } from 'components/common/GlobalFiltersInPage/components/Assignee/Assignee';
import { CardActivityFilter } from 'components/common/GlobalFiltersInPage/components/CardActivityFilter/CardActivityFilter';
import { CompletionPlanSegmentFilter } from 'components/common/GlobalFiltersInPage/components/CompletionPlanSegmentFilter/CompletionPlanSegmentFilter';
import { ImportantFilter } from 'components/common/GlobalFiltersInPage/components/ImportantFilter/ImportantFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFiltersInPage/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { ProgramTagsFilter } from 'components/common/GlobalFiltersInPage/components/ProgramTagsFilter/programTagsFilter';
import { ResourceFilter } from 'components/common/GlobalFiltersInPage/components/ResourceFilter/resourceFilter';
import { StatusFilter } from 'components/common/GlobalFiltersInPage/components/StatusFilter/StatusFilter';
import { TagsFilter } from 'components/common/GlobalFiltersInPage/components/TagsFilter/TagsFilter';
import { UrgentFilter } from 'components/common/GlobalFiltersInPage/components/UrgentFilter/UrgentFilter';
import { WbsFilter } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { BaselineEndDateFilter } from 'components/common/GlobalFiltersInPage/components/baselineEndDateFilter/BaselineEndDateFilter';
import { BaselineStartDateFilter } from 'components/common/GlobalFiltersInPage/components/baselineStartDateFilter/BaselineStartDateFilter';
import { CardTypeFilter } from 'components/common/GlobalFiltersInPage/components/cardTypeFilters/CardTypeFilters';
import { ClusterFilter } from 'components/common/GlobalFiltersInPage/components/clusterFilter/ClusterFilter';
import { DateRangeFilter } from 'components/common/GlobalFiltersInPage/components/dateRangeFilter/dateRangeFilter';
import { DurationFilter } from 'components/common/GlobalFiltersInPage/components/durationFilter/DurationFilter';
import { FinishDateFilter } from 'components/common/GlobalFiltersInPage/components/finishDateFilter/FinishDateFilter';
import { FloatFilter } from 'components/common/GlobalFiltersInPage/components/floatFilter/FloatFilter';
import { HasAttachmentsFilter } from 'components/common/GlobalFiltersInPage/components/hasAttachmentsFilter/HasAttachmentsFilter';
import { HasCommentsFilter } from 'components/common/GlobalFiltersInPage/components/hasCommentsFilter/HasCommentsFilter';
import { LagLeadFilter } from 'components/common/GlobalFiltersInPage/components/lagLeadFilter/LagLeadFilter';
import { ProductivityPreDefinedFilter } from 'components/common/GlobalFiltersInPage/components/productivityPreDefinedFilter/productivityPreDefinedFilter';
import { ProgressMeasurementFilter } from 'components/common/GlobalFiltersInPage/components/progressMeasurementFilter/progressMeasurementFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFiltersInPage/components/quickAnswerFilter/quickAnswerFilter';
import { RelatedActivityFilter } from 'components/common/GlobalFiltersInPage/components/relatedActivityFilter/RelatedActivityFilter';
import { ResourceNameFilter } from 'components/common/GlobalFiltersInPage/components/resourceNameFilter/ResourceNameFilter';
import { ResourceTypeFilter } from 'components/common/GlobalFiltersInPage/components/resourceTypeFilter/ResourceTypeFilter';
import { RiskIndicatorsFilter } from 'components/common/GlobalFiltersInPage/components/riskIndicatorsFilter/RiskIndicatorsFilter';
import { SearchByNameFilter } from 'components/common/GlobalFiltersInPage/components/searchByNameFilter/SearchByNameFilter';
import { StartDateFilter } from 'components/common/GlobalFiltersInPage/components/startDateFilter/StartDateFilter';
import { SubmittedCompletionFilter } from 'components/common/GlobalFiltersInPage/components/submitedCompletionFilter/SubmitedCompletionFilter';
import { TrackedActivity } from 'components/common/GlobalFiltersInPage/components/trackedActivityFilter/TrackedActivityFilter';
import { UpdatedByFilter } from 'components/common/GlobalFiltersInPage/components/updatedByFilter/UpdatedByFilter';
import { WbsLevelFilter } from 'components/common/GlobalFiltersInPage/components/wbsLevelFilter/WbsLevelFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export type GlobalFiltersRegistryKey = GlobalFilterFieldKey;

export const globalFiltersInReportRegistry: Record<GlobalFiltersRegistryKey, React.ComponentType<any>> = {
    cardActivity: CardActivityFilter,
    assignee: Assignee,
    status: StatusFilter,
    tags: TagsFilter,
    activityCodes: ActivityCodesFilter,
    wbs: WbsFilter,
    important: ImportantFilter,
    urgent: UrgentFilter,
    completionPlanSegment: CompletionPlanSegmentFilter,
    hasAttachments: HasAttachmentsFilter,
    lagLead: LagLeadFilter,
    trackedActivity: TrackedActivity,
    milestoneFragnet: MilestoneFragnetFilter,
    activityForwardFragnet: ActivityForwardFragnetFilter,
    cardType: CardTypeFilter,
    finishDate: FinishDateFilter,
    cluster: ClusterFilter,
    duration: DurationFilter,
    float: FloatFilter,
    startDate: StartDateFilter,
    baselineStartDate: BaselineStartDateFilter,
    baselineFinishDate: BaselineEndDateFilter,
    hasComments: HasCommentsFilter,
    relatedActivity: RelatedActivityFilter,
    resourceName: ResourceNameFilter,
    resourceType: ResourceTypeFilter,
    submittedCompletion: SubmittedCompletionFilter,
    updatedBy: UpdatedByFilter,
    wbsLevel: WbsLevelFilter,
    riskIndicators: RiskIndicatorsFilter,
    searchByName: SearchByNameFilter,
    progressMeasurement: ProgressMeasurementFilter,
    resource: ResourceFilter,
    dateRangeFilter: DateRangeFilter,
    productivityPreDefined: ProductivityPreDefinedFilter,
    activityType: ActivityTypeFilter,
    programTags: ProgramTagsFilter,
    quickAnswerFilter: QuickAnswerFilter,
};
